<template>
  <div>
    <div id="top-bar-container">
      <ul id="tpc-list">
        <li>
          <img
            id="tpc-logo"
            src="src/assets/img/logo.jpg"
          >
        </li>
        <li style="margin-left: 5rem;">
          <h2 style="margin: auto; font-weight: bold;">
            QLite Warehouse Tool
          </h2>
        </li>
        <li style="flex-grow: 1; text-align: right;">
          <b-btn :disabled="is_signing_out" variant="outline-primary" id="buttonSignOut" @click="clickedSignOut">
            <i style="margin-right: 0.5rem;" v-show="is_signing_out" class="fa fa-spinner fa-spin"></i>Sign Out
          </b-btn>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import USER_API from '../api/user';
import utils from '../utils.js';

import { mapGetters } from 'vuex'

export default {
	data () {
		return {
      is_signing_out: false
		}
  },
  
  computed: mapGetters({
    user: 'user'
  }),

	mounted () {
		// `this` points to the vm instance
		// Access S3
		console.log('TopBarComponent Mounted')
	},

	methods: {
    clickedSignOut: function() {
      console.debug("clickedSignOut");

      this.is_signing_out = true;

      const reference = this;

      const params = {
        email: this.user.email
      }

      // Call to backend, in order to sign out
      USER_API.sign_out(params,
      () => {
        console.debug("Sign Out Worked");

        reference.is_signing_out = false;

        reference.$store.dispatch('resetDevices');
        reference.$store.dispatch('resetGroups');
        reference.$store.dispatch('resetProducts');
        reference.$store.dispatch('resetProfile');

        reference.$router.push("/");

        utils.makeToast(reference.$bvToast, "Success", "success", "You signed out !");
      },
      e => {
        console.debug(e);

        reference.is_signing_out = false;

        utils.makeToast(reference.$bvToast, "Error", "danger", "We couldn't sign you out");
      })
    }
	}
}
</script>
<!--
  STYLE
-->
<style lang="stylus" scoped>

#top-bar-container
  width: 100%
  padding: 0.6rem
  font-size: 10pt
  background-color: white;
  webkit-box-shadow: 0 1px 10px rgba(0,0,0,.15);
  -moz-box-shadow: 0 1px 10px rgba(0,0,0,.15);
  box-shadow: 0 1px 10px rgba(0,0,0,.15);

#tpc-list
  display: flex;
  align-items: center;
  margin-bottom: 0;

#tpc-list li
    display:inline-block;

#tpc-logo
  width: 5rem;

#text-info-container
  text-align: left;
  font-size: 10pt;
  font-style: italic;
  margin-top: 0.5rem;

</style>
